module.exports = {"220771100":"松原经济技术开发区（特殊乡镇）","220771200":"兴原乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220771.json
// module id = 656
// module chunks = 0